/**
 * Facebook Icon
 * 
 * Uses Font Awesome under the hood for maintained, up-to-date brand icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import type { IconProps } from '../../types';

export function FacebookIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Facebook',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faFacebook}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
